import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Header = ({ user = null, onLogout = () => {} }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const isAuthenticated = !!user;
  const isAdminUser = user?.role === 'admin';

  const customerNavItems = [
  { label: 'Dashboard', path: '/dashboard', icon: 'LayoutDashboard' },
  { label: 'Send Money', path: '/send-money-flow', icon: 'Send' },
  { label: 'Recipients', path: '/recipients-management', icon: 'Users' },
  { label: 'Transactions', path: '/transaction-history', icon: 'History' }];


  const adminNavItems = [
  { label: 'Admin Dashboard', path: '/admin-dashboard', icon: 'Shield' },
  { label: 'Transaction Review', path: '/transaction-review', icon: 'FileCheck' }];


  const navigationItems = isAdminUser ? adminNavItems : customerNavItems;

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  const handleLogout = () => {
    onLogout();
    navigate('/login');
    setIsMobileMenuOpen(false);
  };

  const Logo = () =>
  <div className="flex items-center space-x-2">
      <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
        <Icon name="ArrowRightLeft" size={20} color="white" />
      </div>
      <span className="text-xl font-semibold text-foreground">WIRELINK Pro</span>
    </div>;


  if (!isAuthenticated) {
    return (
      <header className="bg-card border-b border-border sticky top-0 z-navigation">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Logo />
            <div className="flex items-center space-x-4">
              {location?.pathname === '/login' ?
              <Button
                variant="outline"
                onClick={() => navigate('/register')}>

                  Sign Up
                </Button> :

              <Button
                variant="outline"
                onClick={() => navigate('/login')}>

                  Sign In
                </Button>
              }
            </div>
          </div>
        </div>
      </header>);

  }

  return (
    <header className="bg-card border-b border-border sticky top-0 z-navigation">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Logo />

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navigationItems?.map((item) =>
            <button
              key={item?.path}
              onClick={() => handleNavigation(item?.path)}
              className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-150 ${
              location?.pathname === item?.path ?
              'text-primary bg-primary/10' : 'text-muted-foreground hover:text-foreground hover:bg-muted'}`
              }>

                <Icon name={item?.icon} size={16} />
                <span>{item?.label}</span>
              </button>
            )}
          </nav>

          {/* Desktop User Menu */}
          <div className="hidden md:flex items-center space-x-4">
            <Button
              variant="ghost"
              onClick={() => navigate('/profile-management')}
              className="flex items-center space-x-2">

              <Icon name="User" size={16} />
              <span className="text-sm">{user?.name || 'Profile'}</span>
            </Button>
            <Button
              variant="outline"
              onClick={handleLogout}
              iconName="LogOut"
              iconPosition="left"
              iconSize={16}>

              Logout
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <Button
              variant="ghost"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              iconName={isMobileMenuOpen ? "X" : "Menu"}
              iconSize={20} />

          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen &&
        <div className="md:hidden border-t border-border bg-card">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navigationItems?.map((item) =>
            <button
              key={item?.path}
              onClick={() => handleNavigation(item?.path)}
              className={`flex items-center space-x-3 w-full px-3 py-2 rounded-md text-base font-medium transition-colors duration-150 ${
              location?.pathname === item?.path ?
              'text-primary bg-primary/10' : 'text-muted-foreground hover:text-foreground hover:bg-muted'}`
              }>

                  <Icon name={item?.icon} size={20} />
                  <span>{item?.label}</span>
                </button>
            )}
              
              <div className="border-t border-border pt-2 mt-2">
                <button
                onClick={() => handleNavigation('/profile-management')}
                className="flex items-center space-x-3 w-full px-3 py-2 rounded-md text-base font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-colors duration-150">

                  <Icon name="User" size={20} />
                  <span>{user?.name || 'Profile'}</span>
                </button>
                <button
                onClick={handleLogout}
                className="flex items-center space-x-3 w-full px-3 py-2 rounded-md text-base font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-colors duration-150">

                  <Icon name="LogOut" size={20} />
                  <span>Logout</span>
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    </header>);

};

export default Header;